module.exports = __webpack_public_path__ + "img/format_Navisworks_24px_outlined.43d9c85d.png";